import React, { PropsWithChildren } from 'react'
import { Box, BoxProps } from '@node-space/ui-components'

export interface FullScreenLayoutProps extends PropsWithChildren, BoxProps {}

export const FullScreenLayout = ({ children, ...rest }: FullScreenLayoutProps) => {
  return (
    <Box flex centerChildren width="full" minHeight="screen" {...rest}>
      {children}
    </Box>
  )
}
